import React from 'react'
import { QRCode } from 'react-qr-svg'
import { Row, Col, Label, Alert } from 'reactstrap'
import { Button } from '@/components/button'
import LoadingIndicator from '@/components/LoadingIndicator'

const AuthenticatorForm = (props) => {
  if (props.configuring) { return <LoadingIndicator /> }

  const { localize, authenticatorFetching } = props
  const { isAuthenticatorConfigured: isConfigured, authenticatorDetails } = props.twoFactor

  return (
    <React.Fragment>
      <Row><Col><hr /></Col></Row>
      <Row>
        <Col>
          <Label>{localize('Security.AuthenticatorApp')}</Label>
        </Col>
      </Row>
      {isConfigured && (
        <React.Fragment>
          <Row>
            <Col>
              {!authenticatorDetails && <span style={{ marginRight: 10 }}><Button
                icon={authenticatorFetching ? 'loader bx-spin' : null}
                disabled={authenticatorFetching}
                color='primary'
                onClick={props.showAuthenticatorConfiguration}>{localize('Security.ShowAuthenticatorConfiguration')}</Button></span>}
              <Button
                color='primary'
                confirmTitle='Common.Confirmation'
                confirmText='Security.ConfirmRemoveAuthenticator'
                onClick={props.removeAuthenticatorConfiguration}>{localize('Security.RemoveAuthenticatorConfiguration')}</Button>
            </Col>
          </Row>
          {authenticatorDetails &&
            <React.Fragment>
              <Row><Col><p>{localize('Security.AuthenticatorAppInfo')}</p></Col></Row>
              <Row>
                <Col sm='6'>
                  <div><Alert color='success'><kbd>{authenticatorDetails.sharedKey}</kbd></Alert></div>
                </Col>
                <Col sm='6'>
                  <div>
                    {authenticatorDetails.authenticatorUri && <QRCode style={{ width: 256 }} value={authenticatorDetails.authenticatorUri} />}
                  </div>
                </Col>
              </Row>
            </React.Fragment>}
        </React.Fragment>
      )}
      {!isConfigured && <Row>
        <Col>
          <Button color='primary' onClick={props.configureAuthenticator}>{localize('Security.ConfigureAuthenticator')}</Button>
        </Col>
      </Row>}
    </React.Fragment>
  )
}

export {
  AuthenticatorForm
}



// WEBPACK FOOTER //
// ./src/dialogs/twoFactorSetup/authenticatorForm.js